import config from "./config";

export const oauthAuthorize = (params) => {
  // 1. Build the query string from the params object
  const queryString = new URLSearchParams(params).toString();
  
  // 2. Construct the full URL
  // (Assuming config.baseURL is 'https://loginapi.breathehr.com')
  const authUrl = `${config.baseURL}/oauth/authorize?${queryString}`;

  // 3. Redirect the entire browser window
  window.location.href = authUrl;
};